import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/globals';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-reusable-footer',
  templateUrl: './reusable-footer.component.html',
  styleUrls: ['./reusable-footer.component.scss'],
})
export class ReusableFooterComponent implements OnInit {
  isBusinessVersion: boolean;
  stylingVersion: string;

  versionString = this.globals.VERSION_STRING;

  constructor(
    private session: SessionService,
    private globals: Globals
    ) { }

  ngOnInit() { 
    this.isBusinessVersion = this.globals.IS_BUSINESS_VERSION;
    this.stylingVersion = this.isBusinessVersion ? '-biz' : ''
  }

}
